module.exports = "/_next/static/images/c0d95f51057d10637627ba4dff170c55-wow@0.5x.jpg.webp";